import React from "react";
import { motion } from "framer-motion";

const steps = [
  { id: 1, label: "Hoş\nGeldiniz" },
  { id: 2, label: "Doğrulama" },
  { id: 3, label: "Üyelik\nBilgileri" },
  { id: 4, label: "Profil\nBilgileri" },
];

const Header = ({ activeStep = 1 }) => {
  // Eğer activeStep 3 veya 4 ise, stepbar'da 3. tabı aktif göster
  const getActiveTab = () => {
    if (activeStep === 3 || activeStep === 4) return 3;
    if (activeStep >= 5) return 4;
    return activeStep;
  };
  
  const activeTab = getActiveTab();

  // Animasyon varyantları
  const logoVariants = {
    initial: { scale: 0.8, opacity: 0, y: -20 },
    animate: { 
      scale: 1, 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const stepVariants = {
    inactive: {
      scale: 0.95,
      backgroundColor: "rgba(255, 255, 255, 0)",
      color: "#2F646C",
      transition: { duration: 0.3, ease: "easeInOut" }
    },
    active: {
      scale: 1,
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "#787878",
      transition: { 
        duration: 0.4, 
        ease: "easeOut",
        backgroundColor: { duration: 0.2 }
      }
    }
  };

  const containerVariants = {
    initial: { opacity: 0, y: -30 },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  };

  const stepContainerVariants = {
    initial: { opacity: 0, scale: 0.8 },
    animate: { 
      opacity: 1, 
      scale: 1,
      transition: { duration: 0.4 }
    }
  };

  return (
    <motion.div 
      className="w-full flex flex-col items-center"
      variants={containerVariants}
      initial="initial"
      animate="animate"
    >
      <motion.div 
        className="text-center -mb-8"
        variants={logoVariants}
      >
        <img
          src="/assets/pngImages/jodiacLogo.png"
          alt="Jodiac Logo"
          className="h-full  w-[89px] mx-auto"
        />
      </motion.div>
      
      <motion.div 
        className="flex w-full max-w-sm bg-white bg-opacity-40 rounded-full p-2 gap-1 mt-2"
        variants={stepContainerVariants}
      >
        {steps.map((step, idx) => (
          <motion.div
            key={step.id}
            className={`flex-1 p-2 px-3  flex items-center justify-center text-center rounded-full text-[11px] font-semibold min-h-[20px] shadow-sm ${
              activeTab === step.id
                ? "font-bold"
                : ""
            }`}
            variants={stepVariants}
            animate={activeTab === step.id ? "active" : "inactive"}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <motion.span 
              className="block leading-tight font-bold whitespace-pre-line"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: idx * 0.1 }}
            >
              {step.label}
            </motion.span>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default Header;
